module.exports = __webpack_public_path__ + "static/media/cv-agd2021.8766e85a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/cv-agd2021.jpg
// module id = 221
// module chunks = 0